import { Request } from '../../../components/Request';
import { LadderPopup } from '../../../components/LadderPopup';
import { logout as logOutThroughHeader } from 'react/layout/header/logout';

export const FRIEND_REQUEST_BEGIN = 'FRIEND_REQUEST_BEGIN';
export const FRIEND_REQUEST_SUCCESS = 'FRIEND_REQUEST_SUCCESS';
export const FRIEND_REQUEST_FAIL = 'FRIEND_REQUEST_FAIL';

export const UNIGNORE_BEGIN = 'UNIGNORE_BEGIN';
export const UNIGNORE_SUCCESS = 'UNIGNORE_SUCCESS';
export const UNIGNORE_FAIL = 'UNIGNORE_FAIL';

export const IGNORE_BEGIN = 'IGNORE_BEGIN';
export const IGNORE_SUCCESS = 'IGNORE_SUCCESS';
export const IGNORE_FAIL = 'IGNORE_FAIL';

export const FRIENDSHIP_END_POPUP_OPEN = 'FRIENDSHIP_END_POPUP_OPEN';
export const FRIENDSHIP_END_POPUP_CLOSE = 'FRIENDSHIP_END_POPUP_CLOSE';
export const FRIENDSHIP_END_POPUP_CHOOSE_REMOVE = 'FRIENDSHIP_END_POPUP_CHOOSE_REMOVE';

export const UPDATED_MY_USER = 'UPDATED_MY_USER';

export const updatedMyUser = () => {
	return {
		type: UPDATED_MY_USER
	};
};


export const notesPopupOpen = (player = null) => (dispatch, getState) => {

};

export const logout = () => {
	logOutThroughHeader();
};

export const friendRequestUpdate = (player, type) => (dispatch, getState) => {
	const data = {};
	data.player_id = player.id;
	data.type = type;

	if(!player) {
		throw new Error('Player is required');
	}
	if(!type) {
		throw new Error('type is required');
	}

	dispatch({
		type: FRIEND_REQUEST_BEGIN,
		payload: {
			player
		}
	});
	Request.apiv1('player/friends', data)
		.then((response) => {
			if(response.ignores) {
				myUser.update({ ignore_list: response.ignores });
			}
			if(response.friends) {
				myUser.update({ friends: response.friends });
			}
			dispatch({
				type: FRIEND_REQUEST_SUCCESS,
				payload: {
					player
				}
			});
		})
		.catch((response) => {
			Request.generalJsonError(response);
			dispatch({
				type: FRIEND_REQUEST_FAIL,
				payload: {
					player
				}
			});
		});
};

export const acceptFriendRequest = (player) => (dispatch) => {
	dispatch(friendRequestUpdate(player, 'add'));
};

export const declineFriendRequest = (player) => (dispatch) => {
	dispatch(friendRequestUpdate(player, 'decline'));
};

export const cancelSentFriendRequest = (player) => (dispatch) => {
	dispatch(friendRequestUpdate(player, 'cancel'));
};

export const endFriendship = (player) => (dispatch) => {
	dispatch({
		type: FRIENDSHIP_END_POPUP_OPEN
	});
	LadderPopup.create(`Are you sure you want to permanently remove ${player.username}  from your friend list?`, `Removing ${player.username}`, {
		buttons: [
			{
				text: 'Cancel',
				dismiss: true,
			},
			{
				text: 'Remove',
				dismiss: true,
				click: (popup) => {
					dispatch({
						type: FRIENDSHIP_END_POPUP_CHOOSE_REMOVE
					});
					dispatch(friendRequestUpdate(player, 'remove'));
				}
			}
		]
	}).onDismiss.then(() => {
		dispatch({
			type: FRIENDSHIP_END_POPUP_CLOSE
		});
	});
};

export const ignorePlayer = (player) => (dispatch, getState) => {
	dispatch({
		type: IGNORE_BEGIN,
		payload: player
	});
	Request.apiv1('player/ignored', { type: 'add', player_id: player.id })
		.then(() => {
			dispatch({
				type: IGNORE_SUCCESS,
				payload: player,
			});
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: IGNORE_FAIL,
				payload: player,
			});
		});
};
export const unignorePlayer = (player) => (dispatch, getState) => {
	dispatch({
		type: UNIGNORE_BEGIN,
		payload: player
	});
	Request.apiv1('player/ignored', { type: 'remove', player_id: player.id })
		.then(() => {
			dispatch({
				type: UNIGNORE_SUCCESS,
				payload: player,
			});
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: UNIGNORE_FAIL,
				payload: player,
			});
		});
};